import type { UseCase } from '@/core/shared'
import type { UserRepository } from '@/core/user'

export const updateUserRfid: UseCase<UserRepository, 'updateUserRfid'> = repository => {
  return async (rfidUpdate) => {
    await repository.updateUserRfid(rfidUpdate)
  }
}
